import classNames from 'classnames';
import { useSelector } from 'react-redux';

import { currencyFormat } from 'common/helpers/numberHelper';

const Pricing = (props) => {
  const { reservationType } = props;
  const customer = useSelector((state) => state.customer.data);
  const settings = useSelector((state) => state.setting);
  const loyaltyTierReducer = useSelector((state) => state.loyaltyTier);
  const pricingArray = reservationType.loyalty?.pricing || [];

  if (pricingArray.length === 0) {
    return (
      <RetailPrice reservationType={reservationType} settings={settings} />
    );
  }
  return (
    <>
      <RetailPrice reservationType={reservationType} settings={settings} />
      <div className="widget-pricing-wrapper">
        <div className="widget-pricing-title">Member Pricing</div>
        {pricingArray.map((obj) => {
          const { points, price, loyaltyTierId } = obj;
          const tier = loyaltyTierReducer.data[loyaltyTierId]?.title;
          return (
            <div
              className={classNames(
                'widget-pricing-level',
                isCustomerTier(customer, tier) && 'selected'
              )}
              key={loyaltyTierId}
            >
              <span className="widget-pricing-level-tier">{tier}</span>
              <span className="widget-pricing-level-price">
                {' '}
                {currencyFormat(price, settings)} +
              </span>
              <span className="widget-pricing-level-points">
                {' '}
                {points} points
              </span>
            </div>
          );
        })}
      </div>
    </>
  );
};

const RetailPrice = (props) => {
  const { reservationType, settings } = props;
  const price = reservationType.options[0]?.price;
  return (
    <div className="widget-retail-pricing-wrapper">
      <div className="widget-pricing-title">Price</div>
      <span className="widget-retail-price">
        {currencyFormat(price, settings)}
      </span>
    </div>
  );
};

const isCustomerTier = (customer, tier) => {
  if (!customer) {
    return false;
  }
  if (!customer?.loyalty?.tier) {
    return false;
  }
  if (customer.loyalty.tier === tier) {
    return true;
  }
  return false;
};

export default Pricing;
